<template>
	<div
		class="ms-action-icon-btn"
		:class="{
			'ms-action-icon-btn--active': active,
			'ms-action-icon-btn--disabled': disabled,
		}"
		@click="onClick"
		v-tooltip="tooltipOptions"
	>
		<!-- Icon theo prop — chỉ render khi không có slot content -->
		<div v-if="!hasSlotContent" class="mi-new-v2 mi-20" :class="icon"></div>
		<!-- Slot cho phép nhúng trigger phức tạp (ms-config-layout) hoặc icon tùy biến -->
		<slot v-else></slot>
	</div>
</template>

<script>
export default {
	name: 'msActionIconButton',
	props: {
		/**
		 * Class icon (VD: mi-icon-v2-export). Bị bỏ qua khi có default slot.
		 */
		icon: {
			type: [String, Array, Object],
			default: '',
		},
		/**
		 * Nội dung tooltip. Rỗng → không hiển thị tooltip.
		 */
		tooltip: {
			type: String,
			default: '',
		},
		/**
		 * Vị trí hiển thị tooltip.
		 */
		tooltipPlacement: {
			type: String,
			default: 'bottom-end',
		},
		/**
		 * Trạng thái active — đổi border/color sang màu primary.
		 */
		active: {
			type: Boolean,
			default: false,
		},
		/**
		 * Trạng thái disabled — chặn click, giảm opacity.
		 */
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		/**
		 * Xác định có nội dung default slot hay không
		 * @returns {Boolean} true nếu có slot content
		 */
		hasSlotContent() {
			const me = this;
			return !!(me.$slots && me.$slots.default && me.$slots.default.length);
		},
		/**
		 * Cấu hình tooltip — false khi tooltip rỗng để directive không hiển thị
		 * @returns {Object|Boolean} config tooltip hoặc false
		 */
		tooltipOptions() {
			const me = this;
			if (!me.tooltip) {
				return false;
			}
			return {
				content: me.tooltip,
				placement: me.tooltipPlacement,
			};
		},
	},
	methods: {
		/**
		 * Xử lý click — chặn khi disabled và emit event ra component cha
		 * @param {Event} event - Event object
		 */
		onClick(event) {
			const me = this;
			if (me.disabled) {
				return;
			}
			me.$emit('click', event);
		},
	},
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	.ms-action-icon-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		width: $components-action-icon-btn-fix-width;
		height: $components-action-icon-btn-fix-height;
		min-width: $components-action-icon-btn-fix-width;
		min-height: $components-action-icon-btn-fix-height;
		border: 1px solid $ms-border-color;
		border-radius: $components-action-icon-btn-border-radius;
		background-color: $white;
		cursor: pointer;

		&:hover {
			background-color: $button-secondary-hover-bg-color;
		}

		&--active {
			border-color: var(--color-primary);
			color: var(--color-primary);

			&:hover {
				background-color: transparent;
			}
		}

		&--disabled {
			pointer-events: none;
			opacity: 0.5;
			user-select: none;
		}
	}
}

@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	.ms-action-icon-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		width: $components-action-icon-btn-fix-width;
		height: $components-action-icon-btn-fix-height;
		min-width: $components-action-icon-btn-fix-width;
		min-height: $components-action-icon-btn-fix-height;
		border: 1px solid $ms-border-color;
		border-radius: $components-action-icon-btn-border-radius;
		background-color: $white;
		cursor: pointer;

		&:hover {
			background-color: $button-secondary-hover-bg-color;
		}

		&--active {
			border-color: var(--color-primary);
			color: var(--color-primary);

			&:hover {
				background-color: transparent;
			}
		}

		&--disabled {
			pointer-events: none;
			opacity: 0.5;
			user-select: none;
		}
	}
}
</style>
